import { useAppDispatch } from "@/shared/lib/redux"
import { IUser } from "@/shared/api/users"
import { openFillProfileModal as openFillProfileModalAction, closeFillProfileModal as closeFillProfileModalAction } from "../../model"

export const useFillProfileModal = () => {
    const dispatch = useAppDispatch()

    const openFillProfileModal = (user: IUser, onSuccess?: () => void) => {
        dispatch(openFillProfileModalAction({ user, onSuccess }))
    }

    const closeFillProfileModal = () => {
        dispatch(closeFillProfileModalAction())
    }

    return {
        openFillProfileModal,
        closeFillProfileModal
    }
}
